<template>
  <div>
    <el-card>
      <el-input
        style="width: 150px"
        class="m-w"
        v-model="Name"
        placeholder="请输入名称"
      ></el-input>
      <el-input
        style="width: 150px"
        class="m-w"
        v-model="Phone"
        placeholder="请输入手机号"
      ></el-input>
      <el-button type="primary" @click="handleAdd">新增</el-button>

      <el-button type="primary" @click="GetTeacherInfo">查询</el-button>

      <el-button @click="clearData">重置</el-button>
    </el-card>
    <el-card style="margin-top: 20px">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column label="序号" width="60" align="center">
          <template slot-scope="scope">
            {{ scope.$index + (PageIndex - 1) * PageSize + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="TeacherName" label="姓名" align="center">
        </el-table-column>
        <el-table-column label="性别" align="center">
          <template slot-scope="scope">
            {{ scope.row.Sex == 1 ? "男" : "女" }}
          </template>
        </el-table-column>
        <el-table-column prop="LoginCode" label="登录账号" align="center">
        </el-table-column>
        <el-table-column prop="Phone" label="手机号" align="center">
        </el-table-column>
        <el-table-column prop="CreateTime" label="创建时间" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="onClickEdit(scope.row)"
              >编辑</el-button
            >
            <el-button type="text" @click="OpenTeacherRole(scope.row)"
              >管理权限</el-button
            >
            <el-button
              style="color: red"
              type="text"
              @click="onClickDelete(scope.row.Id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="PageIndex"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: center; padding: 20px 0 0 0"
      >
      </el-pagination>
    </el-card>
    <el-dialog
      :title="Title"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      width="25%"
      :before-close="handleClose"
    >
      <el-form
        :model="addForm"
        :rules="addFormRules"
        ref="addForm"
        label-width="100px"
      >
        <el-form-item align="center" label="姓名" prop="teacherName">
          <el-input
            v-model="addForm.teacherName"
            auto-complete="off"
          ></el-input>
        </el-form-item>

        <el-form-item align="center" label="手机号">
          <el-input v-model="addForm.Phone" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="性别">
          <el-radio-group v-model="addForm.sex">
            <el-radio class="radio" :label="1">男</el-radio>
            <el-radio class="radio" :label="0">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item align="center" label="登录账号" prop="loginCode">
          <el-input
            :disabled="Title == '编辑'"
            @input="handleInput"
            v-model="addForm.loginCode"
            auto-complete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="handleClose">取消</el-button>
        <el-button
          type="primary"
          @click.native="
            Title == '新增'
              ? addSubmit('addForm')
              : UpdateTeacherInfo('addForm')
          "
          :loading="addLoading"
          >提交</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="教师权限修改"
      :visible.sync="editFormVisibleRoleclass"
      width="30%"
    >
      <el-tree
        :data="data"
        show-checkbox
        node-key="Id"
        :props="defaultProps"
        ref="tree"
        :default-checked-keys="checked"
        :check-strictly="true"
        :default-expand-all="true"
      >
      </el-tree>

      <span slot="footer" class="dialog-footer">
        <el-button @click="editFormVisibleRoleclass = false">取 消</el-button>
        <el-button type="primary" @click="onEditPreserve">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetTeacherInfo,
  AddTeacherInfo,
  UpdateTeacherInfo,
  GetClassRole,
  AddUserClassRole,
  DeleteTeacherInfo,
} from "../../api/api";

export default {
  data() {
    return {
      tableData: [],
      Phone: "",
      PageIndex: 1,
      PageSize: 10,
      total: 0,
      Name: "",
      addFormVisible: false,
      addForm: {
        id: 0,
        teacherName: "",
        sex: 1,
        Phone: "",
        loginCode: "",
      },
      addFormRules: {
        teacherName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        Phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        loginCode: [{ required: true, message: "请输入账号", trigger: "blur" }],
      },
      Title: "",
      addLoading: false,
      data: [], //树的数据
      checked: [], //默认选中项
      defaultProps: {
        children: "Children",
        label: "Label",
        Id: "Id",
      },
      editFormVisibleRoleclass: false,
      SysUserId: 0,
    };
  },
  created() {
    this.GetTeacherInfo();
  },
  methods: {
    onClickDelete(Id) {
      this.$confirm("此操作将删除该教师数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let res = await DeleteTeacherInfo({ id: Id });
        if (res.data.success) {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.GetTeacherInfo();
        } else {
          this.$message({
            type: "error",
            message: "删除失败!",
          });
        }
      });
    },
    onEditPreserve() {
      let pids = this.$refs.tree.getCheckedKeys();
      var tree = this.data;
      let infos = [];
      tree.forEach((x) => {
        //学届
        x.Children.forEach((y) => {
          //年级
          let yChildren = y.Children;
          for (let z = 0; z < yChildren.length; z++) {
            //班级
            let zid = yChildren[z].Id;
            if (pids.indexOf(zid) != -1) {
              //存在
              infos.push({
                StudyYearId: x.RealId,
                GradeId: y.RealId,
                ClassId: yChildren[z].RealId,
              });
            }
          }
        });
      });
      //console.log(this.userInfo);
      let para = {
        SysUserId: this.SysUserId,
        infos: infos,
      };
      AddUserClassRole(para).then((res) => {
        if (res.data.success) {
          this.editFormVisibleRoleclass = false;
          this.data = [];
          this.$message({
            type: "success",
            message: "分配成功",
          });
        }
      });
    },
    async OpenTeacherRole(item) {
      let res = await GetClassRole({
        SysUserId: item.SysUserId,
      });
      if (res.data.success) {
        this.data = res.data.response.Children;
        this.SysUserId = item.SysUserId;
        var tree = this.data;
        let checked = [];
        tree.forEach((x) => {
          //学届
          if (x.Checked == true) {
            checked.push(x.Id);
          }
          x.Children.forEach((y) => {
            //年级
            if (y.Checked == true) {
              checked.push(y.Id);
            }
            let yChildren = y.Children;
            for (let z = 0; z < yChildren.length; z++) {
              //班级
              if (yChildren[z].Checked == true) {
                checked.push(yChildren[z].Id);
              }
            }
          });
        });
        this.checked = checked;
        //console.log(this.checked);
        this.editFormVisibleRoleclass = true;
      }
    },
    handleClose() {
      this.addForm = {
        id: 0,
        teacherName: "",
        sex: 1,
        Phone: "",
        loginCode: "",
      };
      this.addFormVisible = false;
    },
    onClickEdit(item) {
      this.Title = "编辑";
      this.addFormVisible = true;
      this.addForm = {
        id: item.Id,
        teacherName: item.TeacherName,
        sex: item.Sex,
        Phone: item.Phone,
        loginCode: item.LoginCode,
      };
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.GetTeacherInfo();
    },
    handleSizeChange(val) {
      this.PageSize = val;
      this.GetTeacherInfo();
    },
    UpdateTeacherInfo(formName) {
      this.addLoading = true;
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let res = await UpdateTeacherInfo(this.addForm);
          if (res.data.success) {
            this.$message({
              type: "success",
              message: "成功",
            });
            this.clearData();
            this.addFormVisible = false;
            this.addLoading = false;
            this.$refs[formName].clearValidate();
          } else {
            this.addLoading = false;

            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        } else {
          this.addLoading = false;
          console.log("error submit!!");
          return false;
        }
      });
    },
    addSubmit(formName) {
      this.addLoading = true;
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let res = await AddTeacherInfo(this.addForm);
          if (res.data.success) {
            this.$message({
              type: "success",
              message: "成功",
            });
            this.clearData();
            this.addFormVisible = false;
            this.addLoading = false;
            this.$refs[formName].clearValidate();
          } else {
            this.addLoading = false;

            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        } else {
          this.addLoading = false;
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleInput(value) {
      // 使用正则表达式检查输入的内容是否包含文字
      const reg = /[\u4e00-\u9fa5]/g;
      if (reg.test(value)) {
        // 如果输入内容包含文字，则清空输入框的值
        this.addForm.loginCode = "";
      }
    },
    //显示新增界面
    handleAdd() {
      this.Title = "新增";
      this.addFormVisible = true;
    },
    clearData() {
      this.addForm = {
        id: 0,
        teacherName: "",
        sex: 1,
        Phone: "",
        loginCode: "",
      };
      this.Phone = "";
      this.Name = "";
      this.GetTeacherInfo();
    },
    async GetTeacherInfo() {
      let res = await GetTeacherInfo({
        Phone: this.Phone,
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
        Name: this.Name,
      });
      if (res.data.success) {
        this.tableData = res.data.response.data;
        this.total = res.data.response.dataCount;
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.m-w {
  margin-right: 10px;
}
</style>